import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class EventosContabeisService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  get(form) {
    return this.http
      .post(this.UrlService + 'EventosContabeis/buscar', form)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getEventosContabeis(pagina: number, nome: string) {
    return this.http
      .get(this.UrlService + "EventosContabeis/Paginado?pageIndex=" + pagina + "&search=" + encodeURIComponent(nome))
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getEventoById(id: number) {
    return this.http
      .get(this.UrlService + "EventosContabeis/" + id)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }
}